module.exports = __webpack_public_path__ + "static/circle-1-0b8104df65640a1dd1a0597c23955e11.jpg";